import { render } from "./InactiveCoffeeCustomersList.vue?vue&type=template&id=d9b74f76&scoped=true&ts=true"
import script from "./InactiveCoffeeCustomersList.vue?vue&type=script&lang=ts"
export * from "./InactiveCoffeeCustomersList.vue?vue&type=script&lang=ts"

import "./InactiveCoffeeCustomersList.vue?vue&type=style&index=0&id=d9b74f76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b74f76"]])

export default __exports__